import {SxProps, Theme} from "@mui/material";

export const liquidGlassStyle: SxProps<Theme> = {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.3)',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(7px) saturate(200%)',
    WebkitBackdropFilter: 'blur(7px) saturate(200%)',
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
};
